import React from 'react';
import { trackTelegramClick } from '../lib/trackTelegramClick';

const TELEGRAM_CHANNEL = 'https://t.me/uppercircuitstocksbychiragrathod';

const TelegramFloatingButton = () => (
  <a
    href={TELEGRAM_CHANNEL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackTelegramClick('icon')}
    className="fixed bottom-24 right-6 z-[60] bg-[#229ED9] hover:bg-[#1c8ac2] text-white p-3.5 md:p-4 rounded-full shadow-[0_8px_30px_rgba(34,158,217,0.35)] hover:shadow-[0_12px_40px_rgba(34,158,217,0.55)] transition-all duration-300 hover:scale-110 group"
    aria-label="Join our Telegram channel"
    data-testid="telegram-float-btn"
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 md:w-7 md:h-7">
      <path d="M23.91 3.79L20.3 20.84c-.25 1.21-.98 1.5-2 .94l-5.5-4.07-2.66 2.57c-.3.3-.55.56-1.1.56-.72 0-.6-.27-.84-.95L6.3 13.7l-5.45-1.7c-1.18-.35-1.19-1.16.26-1.75l21.26-8.2c.97-.43 1.9.24 1.53 1.73z" />
    </svg>
    <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-white text-gray-800 px-3 py-1.5 rounded-lg shadow-md text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
      Join our Telegram
    </span>
    <span className="absolute top-0 right-0 w-3 h-3 bg-[#3db8ee] rounded-full animate-ping" aria-hidden="true"></span>
    <span className="absolute top-0 right-0 w-3 h-3 bg-[#229ED9] rounded-full" aria-hidden="true"></span>
  </a>
);

export default TelegramFloatingButton;
